import BtnSearch from './btn-search'

const toggleNav = (nav, openNavBtn) => {
  nav.classList.toggle('--active')
  openNavBtn.classList.toggle('--active')
}

const closeNav = (nav, openNavBtn) => {
  nav.classList.remove('--active')
  openNavBtn.classList.remove('--active')
}

const followme = (header) => {
  if (window.pageYOffset >= header.offsetHeight) {
    header.classList.add('--followme')

    return
  }

  header.classList.remove('--followme')
}

const Nav = () => {
  const header = document.querySelector('header')
  const nav = document.querySelector('nav')
  const openNavBtn = document.querySelector('.open-nav')

  BtnSearch()
  followme(header)

  openNavBtn.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    toggleNav(nav, openNavBtn)
  })

  nav.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  document.addEventListener('click', (e) => {
    if (nav.classList.contains('--active')) closeNav(nav, openNavBtn)
  })

  window.addEventListener('scroll', () => {
    followme(header)
  })
}
export default Nav
